export const zh = {
  // Common
  common: {
    loading: '加载中...',
    error: '错误',
    save: '保存',
    cancel: '取消',
    delete: '删除',
    edit: '编辑',
    add: '添加',
    search: '搜索',
    back: '返回',
    close: '关闭',
    confirm: '确认',
    yes: '是',
    no: '否',
    ok: '确定',
    submit: '提交',
    reset: '重置',
    clear: '清除',
    view: '查看',
    details: '详情',
    settings: '设置',
    logout: '退出登录',
    login: '登录',
    signup: '注册',
    profile: '个人资料',
    collection: '收藏',
    insights: '洞察',
    overview: '概览',
    categories: '分类',
    preorders: '预订',
    recent: '最近',
    total: '总计',
    average: '平均',
    price: '价格',
    quantity: '数量',
    author: '作者',
    publisher: '出版社',
    isbn: 'ISBN',
    genre: '类型',
    type: '种类',
    language: '语言',
    source: '来源',
    date: '日期',
    status: '状态',
    value: '价值',
    items: '项目',
    owned: '拥有',
    preorder: '预订',
    created: '创建时间',
    updated: '更新时间',
    title: '标题',
    description: '描述',
    image: '图片',
    currency: '货币',
    preferences: '偏好设置',
    clone: '复制',
    cloneSuccess: '书籍复制成功',
    cloneError: '复制书籍失败',
    code: '代码'
  },

  // Navigation
  nav: {
    home: '首页',
    collection: '收藏',
    insights: '洞察',
    wishlist: '愿望清单',
    settings: '设置',
    profile: '个人资料',
    logout: '退出登录',
    language: '语言'
  },

  // Landing Page
  landing: {
    title: 'BookPort',
    subtitle: '您的个人图书收藏管理工具',
    description: '轻松整理、跟踪和管理您的图书收藏。从小说到教科书，将所有内容保存在一个美丽、有序的地方。',
    getStarted: '开始使用',
    signUp: '注册',
    goToCollection: '前往收藏',
    sampleCollection: '示例收藏',
    features: {
      title: '强大功能',
      subtitle: '管理图书收藏所需的一切',
      completeManagement: {
        title: '完整的图书管理',
        description: '使用作者、出版社、类型等详细信息整理您的整个图书收藏。'
      },
      smartSearch: {
        title: '智能搜索',
        description: '通过标题、作者、ISBN或出版社的强大搜索功能立即找到您收藏中的任何书籍。'
      },
      multiCurrency: {
        title: '多货币支持',
        description: '通过自动汇率更新以您偏好的货币跟踪图书价值。'
      },
      bookTracking: {
        title: '图书跟踪',
        description: '跟踪您的阅读进度、图书状况和收藏随时间的增长。'
      },
      cloudSync: {
        title: '云端同步',
        description: '通过安全的云端同步从任何地方访问您的图书收藏。'
      },
      secure: {
        title: '安全私密',
        description: '您的图书收藏数据是私密和安全的，采用企业级加密。'
      }
    },
    howItWorks: {
      title: '使用方法',
      subtitle: '通过几个简单步骤开始',
      signUp: {
        title: '注册',
        description: '在几秒钟内创建您的免费账户'
      },
      addBooks: {
        title: '添加图书',
        description: '使用详细信息添加您的图书'
      },
      organize: {
        title: '整理',
        description: '按类型、作者或任何标准整理'
      },
      monitor: {
        title: '监控',
        description: '监控您收藏的增长和价值'
      }
    },
    benefits: {
      title: '为什么选择BookPort？',
      subtitle: '加入数千名信任BookPort管理收藏的图书爱好者',
      neverLose: '永远不会丢失对图书的跟踪',
      trackValue: '跟踪您收藏的价值',
      planPurchases: '规划您的下一次图书购买',
      shareCollection: '与朋友分享您的收藏',
      mobileFriendly: '从任何设备访问',
      freeToUse: '完全免费使用'
    },
    readerTypes: {
      title: '适合所有读者',
      description: '无论您收藏小说、教科书、漫画还是稀有书籍，BookPort都能适应您的收藏风格。',
      startCollection: '开始您的收藏'
    },
    cta: {
      title: '准备好整理您的图书了吗？',
      subtitle: '加入已经使用BookPort整理收藏的数千名图书爱好者。',
      createAccount: '创建账户'
    }
  },

  // Collection
  collection: {
    title: '我的图书收藏',
    addNewBook: '添加新图书',
    addBook: '添加图书',
    searchPlaceholder: '按标题、作者、ISBN或出版社搜索...',
    noBooks: '您的收藏中还没有图书。',
    noSearchResults: '未找到符合搜索条件的图书。',
    addFirstBook: '添加您的第一本图书',
    startBuildingCollection: '通过添加您的第一本图书开始建立您的收藏！',
    tryAdjustingSearch: '请尝试调整您的搜索条件。',
    showingResults: '显示 {total} 本图书中的 {count} 本',
    endOfResults: '您已到达收藏的末尾',
    viewDetailedInsights: '查看详细洞察',
    summary: {
      title: '跟踪和整理您珍贵的图书收藏',
      totalBooks: '图书总数',
      foundBooks: '找到的图书',
      totalValue: '总价值',
      averagePrice: '平均价格',
      totalQuantity: '总数量'
    }
  },

  // Book Detail
  bookDetail: {
    newBook: '添加新图书',
    editBook: '编辑图书',
    title: '标题',
    author: '作者',
    isbn: 'ISBN',
    publisher: '出版社',
    series: '系列',
    genre: '类型',
    type: '种类',
    language: '语言',
    price: '价格',
    quantity: '数量',
    source: '来源',
    imageUrl: '图片URL',
    createdDate: '创建日期',
    notes: '备注',
    save: '保存图书',
    cancel: '取消',
    delete: '删除图书',
    deleteConfirm: '您确定要删除这本图书吗？',
    deleteConfirmDescription: '此操作无法撤销。',
    imagePlaceholder: '无图片'
  },

  // Insights
  insights: {
    title: '收藏洞察',
    subtitle: '关于您图书收藏的详细分析和洞察',
    overview: {
      title: '概览',
      collectionStatus: '收藏状态',
      ownedItems: '拥有的项目',
      preorderItems: '预订项目',
      valueBreakdown: '价值分解',
      ownedValue: '拥有价值',
      preorderValue: '预订价值',
      mostValuableItems: '最有价值的项目'
    },
    categories: {
      title: '分类',
      topPublishers: '热门出版社',
      topGenres: '热门类型',
      topTypes: '热门种类',
      topLanguages: '热门语言',
      topSources: '热门来源'
    },
    preorders: {
      title: '预订',
      preorderSummary: '预订摘要',
      items: '项目',
      totalValue: '总价值'
    },
    recent: {
      title: '最近',
      recentAdditions: '最近添加的项目'
    },
    stats: {
      totalItems: '总项目数',
      totalValue: '总价值',
      totalQuantity: '总数量',
      averagePrice: '平均价格'
    }
  },

  // Settings
  settings: {
    title: '用户设置',
    currency: '货币',
    language: '语言',
    saveSettings: '保存设置',
    settingsSaved: '设置保存成功！',
    settingsError: '保存设置失败',
    currencyDescription: '设置您在应用程序中显示价格的偏好货币。所有价格将转换为您选择的货币。',
    languageDescription: '选择您偏好的应用程序界面语言。语言将立即应用。',
    preferences: '偏好设置'
  },

  // Auth
  auth: {
    login: {
      title: '登录BookPort',
      email: '电子邮件',
      password: '密码',
      signIn: '登录',
      signInWithGoogle: '使用Google登录',
      noAccount: '还没有账户？',
      signUp: '注册',
      forgotPassword: '忘记密码？',
      loginError: '登录失败'
    },
    signup: {
      title: '创建您的账户',
      displayName: '显示名称',
      email: '电子邮件',
      password: '密码',
      confirmPassword: '确认密码',
      signUp: '注册',
      signUpWithGoogle: '使用Google注册',
      haveAccount: '已有账户？',
      signIn: '登录',
      signupError: '创建账户失败',
      passwordMismatch: '密码不匹配'
    }
  },

  // Languages
  languages: {
    en: 'English',
    th: 'ไทย',
    ja: '日本語',
    zh: '中文'
  },

  // Wishlist
  wishlist: {
    title: '愿望清单',
    subtitle: '跟踪您想要添加到收藏中的图书',
    addNewWish: '添加愿望项目',
    addFirstWish: '添加您的第一个愿望项目',
    searchPlaceholder: '搜索愿望清单项目...',
    noWishItems: '您的愿望清单中还没有项目。',
    noSearchResults: '未找到符合搜索条件的愿望清单项目。',
    showingResults: '显示 {count} 个，共 {total} 个项目',
    convertToBook: '转换为图书',
    convert: '是的，我得到了！',
    converting: '转换中...',
    convertConfirm: '您得到了吗？',
    convertConfirmDescription: '这将把此项目从您的愿望清单移动到您的收藏中。之后您可以添加数量和来源信息。',
    deleteConfirm: '删除愿望项目？',
    deleteConfirmDescription: '这将永久删除此愿望项目。此操作无法撤销。',
    // New celebratory conversion messages
    congratulations: '🎉 恭喜！🎉',
    finallyGotIt: '您终于得到了！',
    thatsAwesome: '太棒了！🎊 是时候将这本美丽的图书从您的愿望清单移动到您的收藏中了。您可以添加数量和来源等详细信息。',
    readyToCelebrate: '准备好庆祝这个收藏的新增图书了吗？',
    maybeLater: '稍后再说',
    yesAddToCollection: '🎉 是的，添加到收藏！',
    addingToCollection: '正在添加到收藏...'
  },

  // Currencies
  currencies: {
    USD: '美元',
    THB: '泰铢',
    JPY: '日元',
    CNY: '人民币'
  },


}; 